import { useState } from 'react';
import { X } from 'lucide-react';
import PulseGPTChat from './PulseGPTChat';

const PulseGPTButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Floating Action Button - positioned higher to avoid table actions */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`fixed bottom-20 right-6 w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all duration-300 z-50 overflow-hidden ${
          isOpen 
            ? 'bg-[#111827] hover:bg-[#1F2937]' 
            : 'bg-[#1E293B] hover:bg-[#334155]'
        }`}
        data-testid="pulse-gpt-fab"
        title="Ask PH Pulse GPT"
      >
        {isOpen ? (
          <X className="w-6 h-6 text-white" />
        ) : (
          <img 
            src="https://customer-assets.emergentagent.com/job_9c85cef9-8e5b-4af9-b5f8-e3b78d6826aa/artifacts/fve2vy6a_players-health-logo-color%20%285%29.png" 
            alt="PH Pulse GPT" 
            className="w-8 h-8 object-contain"
          />
        )}
        
        {/* Pulse animation when closed */}
        {!isOpen && (
          <>
            <span className="absolute w-full h-full rounded-full bg-[#1E293B] animate-ping opacity-20"></span>
            <span className="absolute -top-1 -right-1 w-4 h-4 bg-[#22C55E] rounded-full border-2 border-white flex items-center justify-center">
              <span className="text-white text-[8px] font-bold">AI</span>
            </span>
          </>
        )}
      </button>

      {/* Chat Panel */}
      <PulseGPTChat isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default PulseGPTButton;
